import React from 'react'
import { Button, Spacer } from '@components/common'
import { useFormContext } from 'react-hook-form'
import { AllAssetDetailFields } from '@api/models'

interface SectionSaveButtonProps {
  sectionFields: Array<keyof AllAssetDetailFields>
  onSave: (data: AllAssetDetailFields) => Promise<void>
  isLoading?: boolean
  disabled?: boolean
  label?: string
}

const SectionSaveButton: React.FC<SectionSaveButtonProps> = ({
  sectionFields,
  onSave,
  isLoading = false,
  disabled = false,
  label = 'Save changes',
}) => {
  const { getValues, formState: { dirtyFields }, trigger } = useFormContext<AllAssetDetailFields>()

  const isSectionDirty = sectionFields.some(field => dirtyFields[field])

  const handleSectionSave = async () => {
    const isValid = await trigger(sectionFields)
    
    if (isValid) {
      const allValues = getValues()
      await onSave(allValues)
    }
  }

  return (
    <>
      <Spacer y="default" />
      <Button
        onClick={handleSectionSave}
        appearance="primary"
        loading={isLoading}
        disabled={disabled || !isSectionDirty}
      >
        {label}
      </Button>
    </>
  )
}

export default SectionSaveButton

